import React, { Component } from 'react';

//componentes
import InscripcionG from './inscripcionG'

class Index extends Component {

    render(){
        return(
            <div>
                <InscripcionG />
            </div>
        );
    }

}
export default Index;